import {HttpClient, HttpHeaders} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {ConfigurationService} from '../../configuration/services/configuration.service';
import {UserData} from '../../user/models/user-data';
import {MileageRecord} from '../interfaces/mileage-record';

@Injectable({
  providedIn: 'root'
})
export class MileageService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  private headers: HttpHeaders = new HttpHeaders();

  constructor() {
    this.headers = this.headers
      .set('Auth-App-Id', 'awp')
      .set('Content-Type', 'application/json');
  }

  getMileageRecord(vin: string, user: UserData): Promise<MileageRecord> {
    this.setHeaders(user);

    const url = `${this.getMileageServiceHost()}/api/vehicle-information/vehicles/${vin}/mileage`;
    const requestStartMs = (new Date()).getTime();

    return new Promise((resolve, reject) => {
      this.httpClient.get(url, {
          headers: this.headers,
          withCredentials: true
        })
        .subscribe({
          next: (mileageRecord: MileageRecord) => resolve(mileageRecord),
          error: reason => reject(reason),
          complete: () => {
            const requestEndMs = (new Date()).getTime();
            console.debug(`[Webapp] [Mileage Service] Mileage request took ${requestEndMs - requestStartMs}ms.`);
          }
        });
    });
  }

  private getMileageServiceHost(): string {
    return ConfigurationService.getUrlForPortalHost('mileageService');
  }

  private setHeaders(user: UserData): void {
    this.headers = this.headers
      .set('Auth-Dist-Partner', user.getBusinessPartner().getDistributionPartnerNumber())
      .set('Auth-Outlet', user.getBusinessPartner().getOutletNumber());
  }
}
